import axios from '@fs/zion-axios'
import Cache from '@fs/zion-cache'

const defaultCache = new Cache({ storeName: 'surnameDataCache', type: 'session' })

export const fetchSurnameData = async (surname, useCache = true) => {
  if (!surname?.length) {
    throw new Error('Surname is required')
  }

  const cacheKey = `surname-data-${surname.toLowerCase()}`

  if (useCache && defaultCache) {
    const cachedData = await defaultCache.getItem(cacheKey)
    if (cachedData === '__404__' || cachedData === '__NO_RESULTS__') return null
    if (cachedData !== null) return cachedData
  }

  try {
    const params = {
      searchType: 'SURNAME',
      'q.surname': surname.toLowerCase(),
    }

    const queryString = new URLSearchParams(params).toString()
    const response = await axios.get(`/service/search/discovery/orchestration/one-search?${queryString}`)

    const results = response?.data?.results
    if (!results || results.length === 0) {
      if (useCache && defaultCache) {
        await defaultCache.setItem(cacheKey, '__NO_RESULTS__', { ttl: 300 }) // Expires after 5 minutes
      }
      return null
    }

    const surnameResult = results[0]
    // Get only the first 3 countries
    const countries = Array.isArray(surnameResult.countries) ? surnameResult.countries.slice(0, 3) : []
    const variants = surnameResult?.variants?.VARIANT
    const limitedVariants = Array.isArray(variants) ? variants.slice(0, 6) : variants

    const surnameData = {
      surname: surnameResult.surname,
      countries,
      variants: {
        ...surnameResult.variants,
        VARIANT: limitedVariants,
      },
      htmlDefinition: surnameResult.htmlDefinition,
    }

    if (useCache && defaultCache) {
      await defaultCache.setItem(cacheKey, surnameData)
    }

    return surnameData
  } catch (error) {
    console.error('Error fetching surname data:', error)

    if (error.response?.status === 404 && useCache && defaultCache) {
      await defaultCache.setItem(cacheKey, '__404__', { ttl: 300 }) // Expires after 5 minutes
      return null
    }
    return null
  }
}
